import React, { Fragment, useCallback, useEffect, useRef } from 'react';
import { FormikProvider, useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

import { fetchRides, setFilteredStatus, setMyFilter } from '../../../store/rides';
import { renderHeadCells } from './renderHeadCells';
import { LodashHelper } from '../../../utils';
import { useFilterFormikReduxSync } from '../../../hooks/useFilterFormikReduxSync';
import { useFilterStatusHandler } from '../../../hooks/useFilterStatusHandler';
import { Navigation } from '../../../utils/navigation';
import { UBER_VEHICLE_UI_ROLES } from '../../../constants/constants';

export const renderTableHead = ({navigate, healthOrganizations, user}) => () => {
  const filtered = useSelector((state) => state.rides.filtered);
  const myFilterParams = useSelector((state) => state.rides.myFilterParams);
  const isUberEligible =useSelector((state) => state.authorization?.isUberEligible);
  const setUserPermissions = user?.permissions || {};
  const navigate = Navigation();
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: myFilterParams,
    enableReinitialize: true,
  });

  const { onClose } = useFilterStatusHandler(myFilterParams, formik?.values, setFilteredStatus);

  useFilterFormikReduxSync(formik, myFilterParams, dispatch, setMyFilter);

  const fetchRidesData = useCallback(() => dispatch(fetchRides(true, navigate)), [dispatch]);
  const debounceLoadData = useRef(LodashHelper.debounce((values) => fetchRidesData(values), 1000)).current;

  useEffect(() => {
    if (filtered) {
      debounceLoadData();
    }
    return;
  }, [formik.values, filtered, debounceLoadData]);

  return (
    <FormikProvider value={formik}>
      <thead className='ant-table-thead'>
        <tr>
          {renderHeadCells({
            values: formik.values,
            setFieldValue: formik.setFieldValue,
            onClose,
            isUberEligible,
            healthOrganizations,
            user
          }).map((c) => (
            <Fragment key={c.title}>{c.Component}</Fragment>
          ))}
        </tr>
      </thead>
    </FormikProvider>
  );
};
